type Listener = () => void;

function randomThreshold(): number {
  return Math.floor(Math.random() * 6) + 5; // 5–10 inclusive
}

const listeners: Listener[] = [];
let clickCount = 0;
let threshold = randomThreshold();

export function trackOutboundClick(): void {
  clickCount++;
  if (clickCount >= threshold) {
    clickCount = 0;
    threshold = randomThreshold();
    listeners.forEach((fn) => fn());
  }
}

export function onOutboundNag(fn: Listener): () => void {
  listeners.push(fn);
  return () => {
    const i = listeners.indexOf(fn);
    if (i > -1) listeners.splice(i, 1);
  };
}
